import script from "./CallParticipant.vue?vue&type=script&setup=true&lang=ts"
export * from "./CallParticipant.vue?vue&type=script&setup=true&lang=ts"

import "./CallParticipant.vue?vue&type=style&index=0&id=cc7019a8&lang=scss"

const __exports__ = script;

export default __exports__